import { useState } from 'react';

import { Button } from '@/components/ui/Button';
import { FilterBar, type DateRange } from '@/components/ui/FilterBar';

import { State } from '../State';

const STATUS_FILTER = {
  name: 'status',
  label: 'Status',
  options: [
    { value: 'active', label: 'Active' },
    { value: 'draft', label: 'Draft' },
    { value: 'archived', label: 'Archived' },
  ],
};

export function FilterBarExamples() {
  const [search, setSearch] = useState('');
  const [values, setValues] = useState<Record<string, string>>({});
  const [range, setRange] = useState<DateRange>({ from: '', to: '' });
  const [starred, setStarred] = useState(false);

  return (
    <State
      title="Search, a filter, a date range and an extra control"
      note="Clear filters appears once anything is set. To before From is refused against To."
    >
      <FilterBar
        searchValue={search}
        onSearchChange={setSearch}
        searchPlaceholder="Search campaigns"
        filters={[STATUS_FILTER]}
        values={values}
        onFilterChange={(name, value) => setValues((v) => ({ ...v, [name]: value }))}
        dateRange={range}
        onDateRangeChange={setRange}
        extra={
          <Button
            variant={starred ? 'primary' : 'secondary'}
            size="sm"
            onClick={() => setStarred((s) => !s)}
          >
            {starred ? 'Starred only' : 'All campaigns'}
          </Button>
        }
        extraActive={starred}
        onClear={() => {
          setSearch('');
          setValues({});
          setRange({ from: '', to: '' });
          setStarred(false);
        }}
      />
    </State>
  );
}
